import FormControlLabel from '@mui/material/FormControlLabel';
import { styled, SxProps } from '@mui/material/styles';
import { Theme } from '@mui/material/styles';
import MuiSwitch, { SwitchProps as MuiSwitchProps } from '@mui/material/Switch';
import { dsV2 } from '../../ds-v2-tokens';

/* Code supprimé pour des problèmes de build et compatibilité TS avec React 19
// Créer un composant personnalisé qui étend MuiSwitch
const CustomSwitch = (props: MuiSwitchProps) => (
  <MuiSwitch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
);

// Styler le composant personnalisé
const StyledSwitch = styled(CustomSwitch)(({ theme, disabled }: { theme: Theme; disabled: boolean }) => ({
  width: 42,
  height: 24,
  padding: 0,
  opacity: disabled ? '0.3' : '1',
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 3,
    transitionDuration: '300ms',
    color: theme.palette.neutral.white + '!important',
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 1,
    },
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.red[60],
        opacity: 1,
        border: 0,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 18,
    height: 18,
  },
  '& .MuiSwitch-track': {
    borderRadius: 24 / 2,
    backgroundColor: theme.palette.neutral[20],
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));
*/

export type SwitchProps = {
  label?: string;
  onSwitch: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  checked?: boolean;
  id?: string;
  sx?: SxProps<Theme>;
  disabled?: boolean;
  /** `small` : variante compacte Design System V2 (rail fin, bleu dsV2 à l'activation) — proche de la créa. */
  size?: 'small' | 'medium';
};

// Variante compacte V2 (sx inline — l'approche `styled()` casse le build React 19, cf. bloc commenté).
const V2_SMALL_SX: SxProps<Theme> = {
  width: 34,
  height: 20,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: '2px',
    '&.Mui-checked': {
      transform: 'translateX(14px)',
      color: '#fff',
      '& + .MuiSwitch-track': { backgroundColor: dsV2.color.bleu, opacity: 1, border: 0 },
    },
  },
  '& .MuiSwitch-thumb': { width: 16, height: 16, boxShadow: '0 1px 2px rgba(0,0,0,0.25)' },
  '& .MuiSwitch-track': { borderRadius: 10, backgroundColor: dsV2.color.border, opacity: 1 },
};

const FormControlStyled = styled(FormControlLabel)(({ theme }) => ({
  '& .MuiFormControlLabel-label': {
    paddingLeft: '8px',
    color: theme.palette.neutral[80],
    fontSize: '14px',

    [theme.breakpoints.down('lg')]: {
      fontSize: '12px',
    },
  },
  '&.MuiFormControlLabel-labelPlacementEnd': {
    marginLeft: '0px',

    [theme.breakpoints.down('lg')]: {
      margin: '0px',
    },
  },
}));

const Switch = ({ label, onSwitch, checked, id, sx, disabled, size }: SwitchProps) => {
  const isSmall = size === 'small';
  return (
    <FormControlStyled
      control={
        <MuiSwitch
          focusVisibleClassName=".Mui-focusVisible"
          disableRipple
          id={id}
          onChange={onSwitch}
          sx={isSmall ? { ...V2_SMALL_SX, opacity: disabled ? 0.3 : 1 } : { m: 1, opacity: disabled ? '0.3' : '1' }}
          checked={checked}
          disabled={disabled}
        />
      }
      label={label}
      sx={sx}
    />
  );
};

export default Switch;
export { Switch };
